export type QueueAndRunRequests = <TResult>(operation: () => Promise<TResult>) => Promise<TResult>;

export const runRequestWithoutQueueing: QueueAndRunRequests = <TResult>(operation: () => Promise<TResult>): Promise<TResult> => operation();
